import { paginationParam } from 'shared/constant';
import { fixedBankAccounts } from '../../constant/fictures/FixedBankAccounts';
import {
  SET_LIST_SERVICE,
  SET_LIST_FORM,
  SET_LIST_BILLER,
  SET_BILLER,
  SET_BILLER_OF_FORM,
  CHECK_FORM_DELETION,
  SET_SERVICE,
  SET_LIST_AGGREGATOR,
  PROCESSING,
  PROCESSING_DONE,
  SET_FORM,
  SET_LIST_BANK,
  SET_ERROR_DELETE,
  PROCESSING_PREFIX,
  SET_LIST_BILLER_PREFIX,
  PROCESSING_PREFIX_DONE,
  SET_LIST_BILLER_SERVICE,
  SET_LIST_TRANSACTIONS,
  GET_TRANSACTION_DETAIL_MODAL_DATA,
  SET_TRANSACTION_DETAIL_MODAL,
  SET_TRANSACTION_REFUND_CONFIRM_MODAL,
  START_CANCEL_ORDER,
  UPDATE_CANCEL_ORDER,
  RESET_CANCEL_ORDER,
  SET_LIST_SETTLEMENT,
  LOADING_SET_LIST_SETTLEMENT,
  SET_SETTLEMENT_MODAL_VISIBLE,
  UPDATE_SETTLEMENT_UPLOAD_FILELIST,
  UPDATE_SETTLEMENT_UPLOAD_SUCCESS,
  UPDATE_SETTLEMENT_UPLOAD_ERROR,
  UPDATE_SETTLEMENT_UPLOAD_LOADING,
  OPEN_UPLOAD_SETTLEMENT_MODAL,
  UPDATE_CHECK_SETTLEMENT_DATE_LOADING,
  UPDATE_SETTLEMENT_FILE_UPLOADED,
  SET_LIST_BILLER_BANK_ACCOUNT,
  SET_LIST_TNC,
  SET_DETAIL_TNC,
  SET_LIST_PAYMENT_METHOD,
  SET_LIST_PREFERRED_CHANNEL,
  SET_NON_MANDATORY_VA_PREFIX_BANK_LIST,
  SET_BLACKLIST_PAYMENT_METHOD_IN_BILLERS,
} from '../actions/types';

export const initialState = {
  listService: [],
  serviceFilter: paginationParam,
  service: {},
  listForm: [],
  formFilter: paginationParam,
  allowedToDelete: false,
  billerOfForm: [],
  formDetail: {},
  listAggregator: [],
  aggregatorFilter: paginationParam,
  aggregator: {},
  listBiller: [],
  listBillerPrefix: [],
  listBillerBankAccount: fixedBankAccounts,
  listBillerService: [],
  listBank: [],
  listTransactions: [],
  transactionsFilter: paginationParam,
  bank: {},
  biller: {},
  billerFilter: paginationParam,
  listSettlement: [],
  settlementFilter: paginationParam,
  settlementModalVisible: false,
  settlementDate: '',
  checkSettlementDateLoading: false,
  settlementFileUploaded: false,
  settlementUploadFileList: [],
  settlementUploadLoading: false,
  settlementUploadError: '',
  settlementUploadSuccess: false,
  loading: false,
  loadingPrefix: false,
  isErrorDelete: false,
  transactionDetailModalLoading: false,
  transactionDetailModalShow: false,
  transactionDetailModalData: [],
  transactionRefundConfirmModalShow: false,
  transactionRefundSelectedId: '',
  orderInvoices: [],
  getOrderInvoicesLoading: false,
  cancelOrderLoading: false,
  cancelOrderResponse: {},
  cancelOrderError: {},
  tncList: [],
  tncListFilter: paginationParam,
  tncDetail: {},
  listPaymentMethod: [],
  channelList: [],
  nonMandatoryVaPrefixBankList: [],
  blacklistPaymentMethodInBillers: {},
};

export default function(state = initialState, action) {
  switch (action.type) {
    case PROCESSING:
      return {
        ...state,
        loading: true,
      };
    case PROCESSING_PREFIX:
      return {
        ...state,
        loadingPrefix: true,
      };
    case PROCESSING_PREFIX_DONE:
      return {
        ...state,
        loadingPrefix: false,
      };
    case PROCESSING_DONE:
    case SET_ERROR_DELETE:
      return {
        ...state,
        loading: false,
      };
    case SET_SERVICE:
      return {
        ...state,
        service: action.payload,
        loading: false,
      };
    case SET_FORM:
      return {
        ...state,
        formDetail: action.payload,
        loading: false,
      };
    case SET_LIST_AGGREGATOR:
      return {
        ...state,
        listAggregator: action.payload,
        aggregatorFilter: action.filter,
        loading: false,
      };
    case SET_LIST_FORM:
      return {
        ...state,
        listForm: action.payload,
        loading: false,
        formFilter: action.pagination,
      };
    case SET_BILLER_OF_FORM:
      return {
        ...state,
        billerOfForm: action.payload,
        loading: false,
      };
    case CHECK_FORM_DELETION:
      return {
        ...state,
        ...action.payload,
      };
    case SET_LIST_SERVICE:
      return {
        ...state,
        listService: action.payload,
        loading: false,
        serviceFilter: action.pagination,
      };
    case SET_LIST_BILLER:
      return {
        ...state,
        listBiller: action.payload,
        loading: false,
        billerFilter: action.pagination,
      };
    case SET_BILLER:
      return {
        ...state,
        biller: action.payload,
        loading: false,
      };
    case SET_LIST_BILLER_PREFIX:
      return {
        ...state,
        listBillerPrefix: action.payload,
        loadingPrefix: false,
      };
    case SET_LIST_BILLER_BANK_ACCOUNT:
      return {
        ...state,
        listBillerBankAccount: action.payload,
        loadingPrefix: false,
      };
    case SET_LIST_BILLER_SERVICE:
      return {
        ...state,
        listBillerService: action.payload,
        loading: false,
      };
    case SET_LIST_BANK:
      return {
        ...state,
        listBank: action.payload,
        loading: false,
      };
    case SET_LIST_TRANSACTIONS:
      return {
        ...state,
        listTransactions: action.payload,
        loading: false,
        transactionsFilter: action.filter,
      };
    case GET_TRANSACTION_DETAIL_MODAL_DATA:
      return {
        ...state,
        transactionDetailModalLoading: true,
        transactionDetailModalData: [],
      };
    case SET_TRANSACTION_DETAIL_MODAL:
      return {
        ...state,
        transactionDetailModalLoading: false,
        transactionDetailModalShow: action.show,
        transactionDetailModalData: action.data,
      };
    case SET_TRANSACTION_REFUND_CONFIRM_MODAL:
      return {
        ...state,
        transactionRefundConfirmModalShow: action.show,
        transactionRefundSelectedId: action.selectedId,
      };
    case START_CANCEL_ORDER: {
      return {
        ...state,
        cancelOrderLoading: true,
      };
    }
    case UPDATE_CANCEL_ORDER: {
      return {
        ...state,
        cancelOrderLoading: false,
        transactionRefundConfirmModalShow: false,
        cancelOrderResponse: action.response,
        cancelOrderError: action.error,
      };
    }
    case RESET_CANCEL_ORDER: {
      return {
        ...state,
        cancelOrderLoading: initialState.cancelOrderLoading,
        cancelOrderResponse: initialState.cancelOrderResponse,
        cancelOrderError: initialState.cancelOrderError,
      };
    }
    case SET_LIST_SETTLEMENT: {
      return {
        ...state,
        listSettlement: action.payload,
        loading: false,
        settlementFilter: action.filter,
      };
    }
    case LOADING_SET_LIST_SETTLEMENT: {
      return {
        ...state,
        loading: true,
        listSettlement: initialState.listSettlement,
      };
    }
    case SET_SETTLEMENT_MODAL_VISIBLE: {
      return {
        ...state,
        settlementModalVisible: action.visible,
      };
    }
    case UPDATE_SETTLEMENT_UPLOAD_FILELIST: {
      return {
        ...state,
        settlementUploadFileList: action.fileList,
      };
    }
    case UPDATE_SETTLEMENT_UPLOAD_SUCCESS: {
      return {
        ...state,
        settlementUploadSuccess: action.success,
        settlementModalVisible: false,
        settlementUploadLoading: false,
      };
    }
    case UPDATE_SETTLEMENT_UPLOAD_ERROR: {
      return {
        ...state,
        settlementUploadError: action.error,
        settlementUploadLoading: false,
        settlementModalVisible: action.modalVisible || false,
      };
    }
    case UPDATE_SETTLEMENT_UPLOAD_LOADING: {
      return {
        ...state,
        settlementUploadLoading: action.loading,
      };
    }
    case OPEN_UPLOAD_SETTLEMENT_MODAL: {
      return {
        ...state,
        settlementModalVisible: true,
        settlementFileUploaded: initialState.settlementFileUploaded,
        settlementDate: initialState.settlementDate,
        settlementUploadFileList: initialState.settlementUploadFileList,
        settlementUploadLoading: initialState.settlementUploadLoading,
        settlementUploadError: initialState.settlementUploadError,
        settlementUploadSuccess: initialState.settlementUploadSuccess,
      };
    }
    case UPDATE_SETTLEMENT_FILE_UPLOADED: {
      return {
        ...state,
        settlementFileUploaded: action.isUploaded,
        checkSettlementDateLoading: false,
      };
    }
    case UPDATE_CHECK_SETTLEMENT_DATE_LOADING: {
      return {
        ...state,
        checkSettlementDateLoading: action.loading,
        settlementDate: action.dateValue,
        settlementUploadFileList: initialState.settlementUploadFileList,
      };
    }
    case SET_LIST_TNC:
      return {
        ...state,
        tncList: action.payload,
        loading: false,
        tncListFilter: action.pagination,
      };
    case SET_DETAIL_TNC:
      return {
        ...state,
        tncDetail: action.payload,
        loading: false,
      };
    case SET_LIST_PAYMENT_METHOD:
      return {
        ...state,
        listPaymentMethod: action.payload,
        loading: false,
      };
    case SET_LIST_PREFERRED_CHANNEL:
      return {
        ...state,
        channelList: action.payload,
        loading: false,
      };
    case SET_NON_MANDATORY_VA_PREFIX_BANK_LIST:
      return {
        ...state,
        nonMandatoryVaPrefixBankList: action.payload,
        loading: false,
      };
    case SET_BLACKLIST_PAYMENT_METHOD_IN_BILLERS:
      return {
        ...state,
        blacklistPaymentMethodInBillers: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
